import React from "react"

import {unixToDate} from "../../_helpers/date"

const BoxDate = ({date}) => (
    <span className="box-date">{unixToDate(date)}</span>
)

export default BoxDate